import React, { useEffect, useState } from 'react';
import { GetCountries } from '../Country';
import { useTranslation } from "react-i18next";
import FilteringSelect from './common/FilteringSelect';
import { useSelector } from 'react-redux';
import { searchCompanies } from '../store/Actions';
import { copyProperties, deepEquals, isEmpty } from '../Util';
import BuyerSearchResult from './BuyerSearchResult';

const BuyerForm = () => {

    const [formData, setFormData] = useState({
        companyName: '',
        companyVATNumber: '',
        address: {
            postalCode: '',
            city: '',
            countryCode: '',
            streetNumber: '',
            streetName: ''
        }
    });

    const buyerInfo = useSelector((state) => state.Reducer?.buyerAdditionalInformation);
    const [isPopinVisible, setIsPopinVisible] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const { t, i18n } = useTranslation();
    const [searchResult, setSearchResult] = useState(null);
    const [isValidationError, setIsValidationError] = useState(false);
    const [isTvaValidationError, setIsTvaValidationError] = useState(false);
    const dropdownCountries = GetCountries(i18n.language.toUpperCase()); 


    useEffect(() => {
        if (buyerInfo) {
            const filledFormData = { ...formData };           
            copyProperties(buyerInfo, filledFormData);
            setFormData(filledFormData);
        }
    }, []);

    const handleChange = (e) => {
        setIsTvaValidationError(false)
        const { name, value } = e.target;
        if (name.includes(".")) {
            const [parent, child] = name.split(".");
            setFormData((prevState) => ({ ...prevState,
            [parent]: {...prevState[parent], [child]: value} }));
        } else
            setFormData((prevState) => ({...prevState, [name]: value }));
    };

    const handleSearch = async (e) => {
        e.preventDefault();
        setIsValidationError(false);       
        if(!deepEquals(buyerInfo, formData)) 
            setIsValidationError(true);
        else{
            setIsLoading(true);
            await searchCompanies({
                companyName: formData.companyName,
                companyVATNumber: formData.companyVATNumber,
                address: {
                    postCode: formData.address?.postalCode,
                    city: formData.address?.city,
                    countryCode: formData.address?.countryCode,
                    streetNumber: formData.address?.streetNumber,
                    streetName: formData.address?.streetName
                }}, (result) => { setSearchResult(result); setIsPopinVisible(true);}, 
                    () => setIsTvaValidationError(true));
            setIsLoading(false);
        }
    };
    const closePopin = () => {
        setIsPopinVisible(false);
    }

    return (
        <>
            <form className="d-flex row justify-content-center">
                <div className="az-pay-title">
                    {t("buyerSearch.title")}
                </div>

                <div className="middle-font az-pay-subtitle">    
                    {t("buyerSearch.subtitle")}
                </div>
            
                <div className="form-group compact-group">
                    <label htmlFor="companyName" className="form-label az-pay-agreement-label reduced-margin-label pb-1">
                        {t("buyerSearch.companyName.label")} 
                    </label>
                    <input
                        type="text"
                        id="companyName"
                        name="companyName"
                        value={formData.companyName}
                        onChange={handleChange}
                        disabled={!isEmpty(buyerInfo.companyName)}
                        className="form-control"
                    />
                </div>

                <div className="form-group compact-group">
                    <label htmlFor="address.streetName" className="form-label az-pay-agreement-label reduced-margin-label pb-1">
                        {t("buyerSearch.streetName.label")}
                    </label>
                    <input
                        type="text"
                        id="address.streetName"
                        name="address.streetName"
                        value={formData.address.streetName}
                        onChange={handleChange}
                        disabled={!isEmpty(buyerInfo.address.streetName)}
                        className="form-control"
                    />
                </div>

                <div className="form-group compact-group">
                    <label htmlFor="address.streetNumber" className="form-label az-pay-agreement-label reduced-margin-label pb-1">
                        {t("buyerSearch.streetNumber.label")}
                    </label>
                    <input
                        type="text"
                        id="address.streetNumber"
                        name="address.streetNumber"
                        value={formData.address.streetNumber}
                        onChange={handleChange}
                        disabled={!isEmpty(buyerInfo.address.streetNumber)}
                        className="form-control"
                    />
                </div>
                <div className="form-group compact-group">
                    <label htmlFor="address.postalCode" className="form-label az-pay-agreement-label reduced-margin-label pb-1">
                        {t("buyerSearch.postalCode.label")}
                    </label>
                    <input
                        type="text"
                        id="address.postalCode"
                        name="address.postalCode"
                        value={formData.address.postalCode}
                        onChange={handleChange}
                        disabled={!isEmpty(buyerInfo.address.postalCode)}
                        className="form-control"
                    />
                </div>

                <div className="form-group compact-group">
                    <label htmlFor="address.city" className="form-label az-pay-agreement-label reduced-margin-label pb-1">
                        {t("buyerSearch.city.label")}          
                    </label>
                    <input
                        type="text"
                        id="address.city"
                        name="address.city"
                        value={formData.address.city}
                        onChange={handleChange}
                        disabled={!isEmpty(buyerInfo.address.city)}
                        className="form-control"
                    />
                </div>
                
                <div className="form-group compact-group">
                    <label htmlFor="address.countryCode" className="form-label az-pay-agreement-label reduced-margin-label pb-1">
                        {t("buyerSearch.country.label")}               
                    </label>
                    <FilteringSelect
                        id="address.countryCode"
                        name="address.countryCode"
                        value={formData.address.countryCode}
                        onChange={handleChange}
                        options={dropdownCountries}
                        placeholder="buyerSearch.country.placeHolder"
                        disabled={!isEmpty(buyerInfo.address.countryCode)}
                    />
                </div>
                
                <div className="form-group compact-group">
                    <label htmlFor="companyVATNumber" className="form-label az-pay-agreement-label reduced-margin-label pb-1">
                        {t("buyerSearch.id.label")}               
                    </label>
                    <input
                        type="text"
                        id="companyVATNumber"
                        name="companyVATNumber"
                        value={formData.companyVATNumber}
                        onChange={handleChange}
                        className="form-control"
                        disabled={!isEmpty(buyerInfo.companyVATNumber)}
                    />
                </div>

                {isValidationError && <div className="text-danger">{t('buyerSearch.validationError.text')}</div>}
                {isTvaValidationError && <div className="text-danger">{t('buyerSearch.tvaValidationError.text')}</div>}

                <div className="mt-4 d-flex justify-content-start">
                    {isLoading ?
                        <button type="button" className="az-btn" id='company-search-spinner'
                            disabled>
                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        </button>
                        : 
                        <button onClick={handleSearch} className="az-btn">
                            {t("buyerSearch.search.btn")}
                        </button>
                    }
                </div>
            </form>
            
            {isPopinVisible && <BuyerSearchResult result={searchResult} onClose={closePopin} />}
        </>
    );
};

export default BuyerForm;